<template>
    <div>
        <div v-if="$vuetify.breakpoint.lgAndUp">
            <v-data-table
                :headers="headers"
                :items="filteredMatches"
                :items-per-page="-1"
                dense
                hide-default-footer
                class="elevation-0"
                style="background:#141C2E;"
            >
                <template v-slot:[`item.start`]="{ item }">
                    <div class="py-5"><v-icon :style="{color: item.start == 'LIVE' ? 'red' : '#45D25C'}" size="30">mdi-circle-small</v-icon>{{ item.start }}</div>
                </template>
                <template v-slot:[`item.category`]="{ item }">
                    <div><v-img :src="item.category" max-width="30" max-heigth="30" style="margin-left: auto; margin-right: auto;"></v-img></div>
                </template>
                <template v-slot:[`item.leagueName`]="{ item }">
                    <div class="font-weight-bold">{{item.leagueName}}</div>
                </template>
                <template v-slot:[`item.format`]="{ item }">
                    <div class="font-weight-bold">{{item.format}}</div>
                </template>
                <template v-slot:[`item.teamaimg`]="{ item }">
                    <div class="py-3">
                        <v-img :src="item.teamaimg" max-width="35" max-heigth="35" :style="item.teama == 'WIN' ? 'margin-left: auto; margin-right: auto;' : 'opacity:25%; margin-left: auto; margin-right: auto;'"></v-img>
                        <div class="pt-1 text-caption" :style="item.teama == 'WIN' ? 'color:#45D28E;' : 'color:rgba(210, 69, 69, .25)'"><v-icon v-if="item.teama == 'WIN'" x-small class="pr-1" color="#D28945">mdi-crown</v-icon> {{item.teamaname}}</div>
                    </div>
                </template>
                <template v-slot:[`item.teama`]="{ item }">
                    <div><v-chip class="px-4" small :style="item.teama == 'WIN' ? 'background:rgba(69, 210, 142, .5)' : 'background:rgba(210, 69, 69, .25); color:rgba(255, 255, 255, .5)'">{{ item.teama }}</v-chip></div>
                </template>
                <template v-slot:[`item.draw`]="{ item }">
                    <div v-if="item.draw == null">VS</div>
                    <div v-else-if="item.draw == 'WIN'" class="mt-5">
                        <div>
                        <v-chip class="px-4" small :style="item.draw == 'WIN' ? 'background:rgba(69, 210, 142, .5)' : 'background:rgba(210, 69, 69, .25); color:rgba(255, 255, 255, .5)'">
                            {{ item.draw }}
                        </v-chip>
                        <div v-if="item.draw == 'WIN'" class="text-caption" style="font-size:10px !important;"><v-icon x-small class="pr-1" color="#D28945">mdi-crown</v-icon> DRAW</div>
                        </div>
                    </div>
                    <div v-else>
                        <v-chip class="px-4" small :style="item.draw == 'WIN' ? 'background:rgba(69, 210, 142, .5)' : 'background:rgba(210, 69, 69, .25); color:rgba(255, 255, 255, .5)'">
                            {{ item.draw }}
                        </v-chip>
                        <div v-if="item.draw == 'WIN'" class="pt-1 text-caption" style="font-size:10px !important;"><v-icon x-small class="pr-1" color="#D28945">mdi-crown</v-icon> DRAW</div>
                    </div>
                </template>
                <template v-slot:[`item.teamb`]="{ item }">
                    <div><v-chip class="px-4" small :style="item.teamb == 'WIN' ? 'background:rgba(69, 210, 142, .5)' : 'background:rgba(210, 69, 69, .25); color:rgba(255, 255, 255, .5)'">{{ item.teamb }}</v-chip></div>
                </template>
                <template v-slot:[`item.teambimg`]="{ item }">
                    <div class="py-3">
                        <v-img :src="item.teambimg" max-width="35" max-heigth="35" :style="item.teamb == 'WIN' ? 'margin-left: auto; margin-right: auto;' : 'opacity:25%; margin-left: auto; margin-right: auto;'"></v-img>
                        <div class="pt-1 text-caption" :style="item.teamb == 'WIN' ? 'color:#45D28E;' : 'color:rgba(210, 69, 69, .25)'"><v-icon v-if="item.teamb == 'WIN'" x-small class="pr-1" color="#D28945">mdi-crown</v-icon> {{item.teambname}}</div>
                    </div>
                </template>
                <template v-slot:[`item.other`]="{ item }">
                    <div><a class="text-decoration-underline" style="color: #D28945">{{ item.other }}</a></div>
                </template>
            </v-data-table>
        </div>
        <div v-else style="background:#141C2E" class="pt-3">
            <v-col>
                <v-row v-for="(item, idx) in filteredMatches" :key="idx" class="mb-1">
                    <v-col>
                        <v-card flat tile color="transparent">
                            <v-row class="pb-1">
                                <v-col class="pa-0">
                                    <v-card flat tile color="rgba(13, 17, 27, .75)">
                                        <v-row  class="d-flex align-center">
                                            <v-col cols="3">
                                                <div class="d-flex align-center text-caption pr-2" :style="item.start == 'LIVE' ? 'font-size:10px !important;' : 'font-size:8px !important;'"><v-icon :style="{color: item.start == 'LIVE' ? 'red' : '#45D25C'}">mdi-circle-small</v-icon>{{ item.start == 'LIVE' ? item.start : '1hr 7min' }}</div>
                                            </v-col>
                                            <v-col cols="6" class="px-0">
                                                <div class="font-weight-bold text-caption" style="font-size:10px !important;">{{item.leagueName}}</div>
                                            </v-col>
                                            <v-col cols="3">
                                                <div class="float-end pr-3"><v-img :src="item.category" max-width="18" max-heigth="18" style="opacity:50%;"></v-img></div>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="pa-0">
                                    <v-card flat tile color="rgba(13, 17, 27, .75)" class="py-3">
                                        <v-row>
                                            <v-col cols="4" class="pb-0 pr-0 d-flex align-end">
                                                <v-img :src="item.teamaimg" max-width="25" max-heigth="25" :style="item.teama == 'LOSE' ? 'margin-left: auto; margin-right: auto; opacity:50%;' : 'margin-left: auto; margin-right: auto;'"></v-img>
                                            </v-col>
                                            <v-col cols="4" class="pb-0 px-0">
                                                <div>
                                                    <div class="text-caption" style="font-size:8.5px !important;">{{item.format}}</div>
                                                    <div class="d-flex justify-space-around">
                                                        <div><v-chip x-small :color="item.teama == 'WIN' ? 'rgba(69, 210, 142, .75)' : 'rgba(210, 69, 69, .25)'" :style="item.teama == 'WIN' ? '' : 'color:rgba(255, 255, 255, .5)'">{{item.teama}}</v-chip></div>
                                                        <div v-if="item.draw != null">
                                                            <v-chip x-small class="mx-1" :color="item.draw == 'WIN' ? 'rgba(69, 210, 142, .75)' : 'rgba(210, 69, 69, .25)'" :style="item.draw == 'WIN' ? '' : 'color:rgba(255, 255, 255, .5)'">{{item.draw}}</v-chip>
                                                        </div>
                                                        <div v-else style="font-size:8.5px !important;" class="d-flex align-center">VS</div>
                                                        <div><v-chip x-small :color="item.teamb == 'WIN' ? 'rgba(69, 210, 142, .75)' : 'rgba(210, 69, 69, .25)'" :style="item.teamb == 'WIN' ? '' : 'color:rgba(255, 255, 255, .5)'">{{item.teamb}}</v-chip></div>
                                                    </div>
                                                </div>
                                            </v-col>
                                            <v-col cols="4" class="pb-0 pl-0 d-flex align-end">
                                                <v-img :src="item.teambimg" max-width="25" max-heigth="25" :style="item.teamb == 'LOSE' ? 'margin-left: auto; margin-right: auto; opacity:50%;' : 'margin-left: auto; margin-right: auto;'"></v-img>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="4" class="pt-0 pr-0">
                                                <div class="text-caption font-weight-bold" :style="item.teama == 'WIN' ? 'color:#45D28E;font-size:8.5px !important;' : 'color:rgba(210, 69, 69, .25);font-size:8.5px !important;'"><v-icon v-if="item.teama == 'WIN'" color="#D28945" x-small>mdi-crown</v-icon> {{item.teamaname}}</div>
                                            </v-col>
                                            <v-col cols="4" class="pt-0 px-0">
                                                <div class="text-caption font-weight-bold" :style="item.draw == 'WIN' ? 'color:#45D28E;font-size:8.5px !important;' : 'color:rgba(210, 69, 69, .25);font-size:8.5px !important;'"><v-icon v-if="item.draw == 'WIN'" color="#D28945" x-small>mdi-crown</v-icon> {{item.draw != null ? 'DRAW' : ''}}</div>
                                            </v-col>
                                            <v-col cols="4" class="pt-0 pl-0">
                                                <div class="text-caption font-weight-bold" :style="item.teamb == 'WIN' ? 'color:#45D28E;font-size:8.5px !important;' : 'color:rgba(210, 69, 69, .25);font-size:8.5px !important;'"><v-icon v-if="item.teamb == 'WIN'" color="#D28945" x-small>mdi-crown</v-icon> {{item.teambname}}</div>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </div>
        <div style="background-color:#141C2E;">
            <v-btn plain class="mb-1">see more <v-icon>mdi-arrow-down-thin</v-icon></v-btn>
        </div>
    </div>
</template>
<script>
export default {
    props: ["selected_tab"],
    data () {
        return {
            tab: null,
            headers: [
                { text: 'Start', align: 'start', class: 'pl-6', sortable: false, value: 'start' },
                { text: 'Category', align: 'center', sortable: false, value: 'category' },
                { text: 'League Name', align: 'center', sortable: false, value: 'leagueName' },
                { text: 'Format', align: 'center', sortable: false, value: 'format' },
                { text: '', align: 'center', sortable: false, value: 'teamaimg' },
                { text: 'Team A', align: 'center', sortable: false, value: 'teama' },
                { text: 'Draw', align: 'center', sortable: false, value: 'draw' },
                { text: 'Team B', align: 'center', sortable: false, value: 'teamb' },
                { text: '', align: 'center', sortable: false, value: 'teambimg' },
                { text: 'Other Markets', align: 'center', sortable: false, value: 'other' }
            ],
            matches: [
                {
                    id: 1,
                    start: 'LIVE',
                    category_name: 'Dota',
                    category: require('@/assets/images/Dota.svg'),
                    leagueName: "DPC SEA TOUR 3: DIVISION II",
                    format: "Best of 2 (BO2)",
                    teama: "WIN",
                    draw: "LOSE",
                    teamb: "LOSE",
                    teamaimg: require('@/assets/images/Boom.svg'),
                    teambimg: require('@/assets/images/Yangon_Galacticos.svg'),
                    teamaname: "Boom Esports",
                    teambname: "Yangon Galacticos",
                    other: 'RESULTS >>'
                },
                {
                    id: 2,
                    start: '1h 7m 37s from now',
                    category_name: 'Dota',
                    category: require('@/assets/images/Dota.svg'),
                    leagueName: "DPC SEA TOUR 3: DIVISION II",
                    format: "Best of 2 (BO2)",
                    teama: "LOSE",
                    draw: "WIN",
                    teamb: "LOSE",
                    teamaimg: require('@/assets/images/Fnatic.svg'),
                    teambimg: require('@/assets/images/Virtus.svg'),
                    teamaname: "Fnatic",
                    teambname: "Virtus.pro",
                    other: 'RESULTS >>'
                },
                {
                    id: 3,
                    start: '1h 7m 37s from now',
                    category_name: 'CS:GO',
                    category: require('@/assets/images/CSGO.svg'),
                    leagueName: "PINNACLE CUP SEASON 22",
                    format: "Best of 3 (BO3)",
                    teama: "LOSE",
                    draw: null,
                    teamb: "WIN",
                    teamaimg: require('@/assets/images/Boom.svg'),
                    teambimg: require('@/assets/images/Virtus.svg'),
                    teamaname: "Boom Esports",
                    teambname: "Virtus.pro",
                    other: 'RESULTS >>'
                },
                {
                    id: 4,
                    start: '2h 7m 37s from now',
                    category_name: 'CS:GO',
                    category: require('@/assets/images/CSGO.svg'),
                    leagueName: "PINNACLE CUP SEASON 22",
                    format: "Best of 3 (BO3)",
                    teama: "LOSE",
                    draw: null,
                    teamb: "WIN",
                    teamaimg: require('@/assets/images/Virtus.svg'),
                    teambimg: require('@/assets/images/Fnatic.svg'),
                    teamaname: "Virtus.pro",
                    teambname: "Fnatic",
                    other: 'RESULTS >>'
                },
                {
                    id: 5,
                    start: '3h 7m 37s from now',
                    category_name: 'LOL',
                    category: require('@/assets/images/LOL.svg'),
                    leagueName: "LPL Summer 2022",
                    format: "Best of 3 (BO3)",
                    teama: "WIN",
                    draw: null,
                    teamb: "LOSE",
                    teamaimg: require('@/assets/images/IG.svg'),
                    teambimg: require('@/assets/images/Yangon_Galacticos.svg'),
                    teamaname: "Invictus Gaming",
                    teambname: "Yangon Galacticos",
                    other: 'RESULTS >>'
                },
                {
                    id: 6,
                    start: '3h 7m 37s from now',
                    category_name: 'LOL',
                    category: require('@/assets/images/LOL.svg'),
                    leagueName: "LPL Summer 2022",
                    format: "Best of 3 (BO3)",
                    teama: "LOSE",
                    draw: null,
                    teamb: "WIN",
                    teamaimg: require('@/assets/images/Victory_Five.svg'),
                    teambimg: require('@/assets/images/Boom.svg'),
                    teamaname: "Victory Five",
                    teambname: "Boom Esports",
                    other: 'RESULTS >>'
                },
                {
                    id: 7,
                    start: '3h 7m 37s from now',
                    category_name: 'LOL',
                    category: require('@/assets/images/Valorant.svg'),
                    leagueName: "VCT 2022: APAC Challengers 2",
                    format: "Best of 3 (BO3)",
                    teama: "LOSE",
                    draw: "WIN",
                    teamb: "LOSE",
                    teamaimg: require('@/assets/images/IG.svg'),
                    teambimg: require('@/assets/images/Xerxia.svg'),
                    teamaname: "Invictus Gaming",
                    teambname: "Xerxia Esports",
                    other: 'RESULTS >>'
                },
                {
                    id: 8,
                    start: '3h 7m 37s from now',
                    category_name: 'LOL',
                    category: require('@/assets/images/Valorant.svg'),
                    leagueName: "VCT 2022: APAC Challengers 2",
                    format: "Best of 3 (BO3)",
                    teama: "WIN",
                    draw: null,
                    teamb: "LOSE",
                    teamaimg: require('@/assets/images/RRQ.svg'),
                    teambimg: require('@/assets/images/Fnatic.svg'),
                    teamaname: "RRQ",
                    teambname: "Fnatic",
                    other: 'RESULTS >>'
                }
            ],
            filteredMatches: []
        }
    },
    mounted() {
        this.filteredMatches = this.matches;
    },
    watch: {
        async selected_tab () {
            this.category = await this.selected_tab;
            if (this.category != 'All') {
                this.filteredMatches = await this.matches.filter(this.getMatchesByCategory);
            } else {
                this.filteredMatches = this.matches;
            }
        }
    },
    methods: {
        getMatchesByCategory(category){
            return category.category_name == this.category;
        }

    }
};
</script>
<style scoped>
.v-data-table >>> div > table {
    text-indent: 0;
    border-color: inherit;
    border-collapse: unset !important;
    border-spacing: 0px 5px !important;
}
.v-data-table >>> div > table > tbody > tr {
    border-bottom: none !important;
    background-color:rgba(13, 17, 27, .75);
}
.v-data-table >>> div > table > tbody > tr > td {
    border-bottom: none !important;
}
.v-data-table >>> div > table > thead > tr > th {
    border: none !important;
}
.v-data-table--mobile >>> div > table > tbody > tr {
    margin-bottom: 10px !important;
}
.v-data-table >>> div > table > tbody > tr > td:nth-child(2) > div > div {
    opacity: 50%;
}
.v-data-table >>> div > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
    background-color: rgba(13, 17, 27, 1) !important;
}
.v-data-table >>> div > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) > td:nth-child(2) > div > div {
    opacity: 100%;
}
</style>